import {React, useState, useEffect} from 'react';
import '../../App.css'
import axios from 'axios';
import { Grid, TextField, Box, Button, Paper, Stack, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio,FormHelperText,Typography} from '@mui/material';
import {PersonAddAlt1, ArrowForwardIos, RestartAlt} from '@mui/icons-material';
import PF_DetailsForm from './PF_DetailsForm';
import * as employeeService from '../../services/employeeService';
import { BiSave } from "react-icons/bi";
import Popup from '../Popup';
import Notification from '../Notification';
import { useNavigate } from 'react-router-dom';

const options = employeeService.getDepartmentCollection();

const initialFValues={
  id: 0,
  bankName: '',
  branchName: '',
  accountType: '',
  bankAcNumber: '',
  bankContactPerson: '',
  email: '',
  internetBankingId: '',
}

const RequiredLabel = ({ label }) => (  
  <span>
    {label}
    <span style={{ color: 'red', marginLeft: '3px' }}>*</span>
  </span>
);

function CompanyBankAccountsForm(props){
  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});
  const [checked, setChecked] = useState(false);
  const [selectedDate, setSelectedDate] =  useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [companies, setCompanies] = useState({});
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const navigate = useNavigate();

  const validate = () => {
    let temp = {};
    // Check if bankName is not empty
    temp.bankName = values.bankName ? "" : "This field is required.";
    // Check if bankAcNumber is not empty
    temp.bankAcNumber = values.bankAcNumber ? "" : "This field is required.";
    // Check if branchName is not empty
    temp.branchName = values.branchName ? "" : "This field is required.";
    // Check if email is not empty and is a valid email format
    temp.email = values.email ? ((/$^|.+@.+..+/).test(values.email) ? "" : "Email is not valid.") : "This field is required.";
    
    // The other fields are now optional and are not validated here.

    setErrors({
      ...temp
    })

    return Object.values(temp).every(x => x === "")
  }

  const resetForm = () => {
    setValues(initialFValues);
    setErrors({});
  }


  const convertToDefEventPara = (name, value) => ({
    target: {
      name: name,
      value: value
    }
  })

  function handleInputChange(e){
    const {name, value} = e.target;
    setValues({
      ...values,
      [name]: value
    })
    if (errors[name]) {
      setErrors({
          ...errors,
          [name]: ''
      });
  }
  }

  useEffect(() => {
    async function getCompanies(){
      if(props.fetch_id !== 9999) {
        try {
          const companies =  await axios.get(`${process.env.REACT_APP_API_BASE_URL}/company-master/get-company-bank-details/` + props.fetch_id);
          setCompanies(companies.data[0]);

          const editFValues = {
            // initial : employees.data[0].initial,
            bankName: companies.data[0].bank_name,
            branchName: companies.data[0].branch_name,
            accountType: companies.data[0].account_type,
            bankAcNumber: companies.data[0].bank_ac_number || '',
            bankContactPerson: companies.data[0].contact_person,
            email: companies.data[0].email_id,
            internetBankingId: companies.data[0].internet_banking_id || '',
         
          }

          setValues(editFValues);


        } catch (e) {
          if(e.response.status === 401) {
            setNotify({
              isOpen: true,
              message: 'Session Expired!',
              type: 'error'
            });
            setTimeout(() => {
              navigate('/');
            },1000);
          }
        }
      } else {
        setValues(initialFValues)
      }
      }
    getCompanies();

  },[]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Check if the form is valid before submitting
    if (validate()) {
      let API_URL = '';
      let idValue = 0;
      if(props.fetch_id === 9999) {
        idValue = props.companyID;
        API_URL = `${process.env.REACT_APP_API_BASE_URL}/company-master/add-company-bank-details`;
      } else {
        idValue = props.fetch_id;
        API_URL = `${process.env.REACT_APP_API_BASE_URL}/company-master/edit-company-bank-details/` + props.fetch_id;
      }
      
      // Transform values to match API payload format
      const payload = {
        ...values,
        id: idValue,
        bank_ac_number: values.bankAcNumber,
        internet_banking_id: values.internetBankingId
      };
      delete payload.bankAcNumber;
      delete payload.internetBankingId;
      
      axios.post(API_URL, payload)
      .then(function (response) {
        if(response.status === 200) {
          setNotify({
            isOpen: true,
            message: response.data.message,
            type: 'success'
          });
        }
      })
      .catch(function (e) {
        if(e.response.status === 401) {
          setNotify({
            isOpen: true,
            message: 'Session Expired!',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/');
          },1000);
        }
      });
    }
  }

  return(
    <Box sx={{display: "flex" ,marginTop: "-30px", justifyContent: "center", margin: "-20px", padding: "50px", fontWeight: "500px"}}>
      <Paper elevation={5} sx={{width: "500px"}}>
        <Grid className="form-title" container spacing={2}>
          <Grid item> <Typography variant="h5" sx={{textAlign: "center", margin: 5}}>Company Bank Accounts</Typography> </Grid>
          <Grid item> <PersonAddAlt1 style={{marginLeft: "-30px"}} sx={{width: 45, height: 45}}/> </Grid>
        </Grid>
        <form className="classes.root" autoComplete="off" onSubmit={handleSubmit}>

          <Stack spacing={3} sx={{margin: "30px"}}>
            <TextField
              variant="outlined"
              name="bankName"
              label={<RequiredLabel label="Bank Name"/>}
              size="small"
              value={values.bankName}
              onChange={handleInputChange}
              {...(errors.bankName && {error:true, helperText: errors.bankName} )}
            />
            <TextField
              variant="outlined"
              label="Bank Account Number"
              name="bankAcNumber"
              value={values.bankAcNumber}
              size="small"
              onChange={handleInputChange}
              {...(errors.bankAcNumber && {error:true, helperText: errors.bankAcNumber} )}
            />
            <TextField
              variant="outlined"
              name="branchName"
              label={<RequiredLabel label="Branch Name"/>}
              size="small"
              value={values.branchName}
              onChange={handleInputChange}
              {...(errors.branchName && {error:true, helperText: errors.branchName} )}
            />

            <FormControl>
              <FormLabel>Account Type</FormLabel>
              <RadioGroup
                row={true}
                name="accountType"
                value={values.accountType}
                onChange={handleInputChange}
              >
                <FormControlLabel value="1" control={<Radio />} label="Saving" />
                <FormControlLabel value="2" control={<Radio />} label="Current" />
              </RadioGroup>
              { errors.accountType && <FormHelperText>{errors.accountType}</FormHelperText>}
            </FormControl>

            <TextField
              variant="outlined"
              label="Bank Contact Person"
              name="bankContactPerson"
              value={values.bankContactPerson}
              size="small"
              onChange={handleInputChange}
              {...(errors.bankContactPerson && {error:true, helperText: errors.bankContactPerson} )}
            />

            <TextField
              variant="outlined"
              label={<RequiredLabel label="E-mail"/>}
              name="email"
              value={values.email}
              size="small"
              onChange={handleInputChange}
              {...(errors.email && {error:true, helperText: errors.email} )}
            />

            <TextField
              variant="outlined"
              label="Internet Banking ID"
              name="internetBankingId"
              value={values.internetBankingId}
              size="small"
              onChange={handleInputChange}
              {...(errors.internetBankingId && {error:true, helperText: errors.internetBankingId} )}
            />

            <Grid container className="space-around">
              <Grid item>
              <Button className="form-btn" variant="contained" color="error" endIcon={<RestartAlt />} onClick={resetForm}>Reset</Button>
              </Grid>
              <Grid item>
              <Button className="form-btn" variant="contained" color="success" endIcon={<BiSave/>}type="submit">Submit</Button>
              </Grid>
            </Grid>

            </Stack>
        </form>

        <Stack className="end-align" >
          <Button className="form-btn" variant="outlined" onClick={() => setOpenPopup(true)} endIcon={<ArrowForwardIos/>} >Next</Button>
        </Stack>

        <Popup
          title="PF Details"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <PF_DetailsForm companyID={props.companyID} fetch_id={props.fetch_id} />
        </Popup>
      </Paper>
      <Notification
            notify={notify}
            setNotify={setNotify} />
    </Box>
  )
}

export default CompanyBankAccountsForm;
